<template>
  <div>
    <div class="ordercontractbox" :style="{'margin':tablemargin,'padding':tablePadding}">
      <h2 class="title">
        北京星网锐捷网络技术有限公司
      </h2>
      <p class="m-title">
        经销代理商订货合同
      </p>
      <div class=" ht el-table el-table--border el-table--fit el-table--striped el-table--enable-row-hover el-table--enable-row-transition">
        <div class="el-table__body-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
            <colgroup>
              <col width="47%">
              <col width="25%">
              <col width="28%">
            </colgroup>
            <tbody>
              <tr class="el-table__row">
                <td colspan="2">
                  <div class="cell">
                    供货单位(甲方)： <span class="fang">{{ poinfo.supplyUnitName }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    合同编号： <span class="fang">{{ poinfo.businessContractCode }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="2">
                  <div class="cell">
                    公司地址： <span class="fang">{{ poinfo.supplyUnitAddress }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    供货单位电话(甲方)： <span class="fang">{{ poinfo.supplyUnitTel }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="2">
                  <div class="cell">
                    订货单位(乙方)： <span class="fang">{{ poinfo.buyerName }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    订货单位电话(乙方)： <span class="fang">{{ poinfo.buyerTel }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="3">
                  <div class="cell">
                    公司地址： <span class="fang">{{ poinfo.buyerAddress }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td>
                  <div class="cell">
                    收货单位： <span class="fang">{{ consigneeName }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    收货人： <span class="fang">{{ consigneeUserName1 }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    邮编： <span class="fang">{{ finalPostalCode }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="2">
                  <div class="cell">
                    收货地址： <span class="fang">{{ consigneeAddress }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    收函人： <span class="fang">{{ recipients }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="2">
                  <div class="cell">
                    收货电话： <span class="fang">{{ consigneeTel1 }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    收货传真： <span class="fang">{{ consigneeFax1 }}</span>
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td colspan="3">
                  <div class="cell" style="margin-top: 25px">
                    双方一致同意选择以下第_______项供货时限(供货时限与本合同"订单条款"第1条A项有冲突者，以第1条A项约定为准)：
                  </div>
                  <div class="cell" style="margin-top: 10px">
                    A、合同生效后_______个工作日内； B.货已供，乙方已全部收到； C、甲方确认的供货日期_____________ 。
                  </div>
                </td>
              </tr>
              <tr class="el-table__row">
                <td>
                  <div class="cell">
                    最终用户项目名称： <span class="fang">{{ poinfo.oppName }}</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    最终用户所属省份： <span class="fang">_______</span>
                  </div>
                </td>
                <td>
                  <div class="cell">
                    甲方业务联系人： <span class="fang">{{ poinfo.salesmanName }}</span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="content-text">
        <p>依据甲乙双方签订的代理合作协议，经双方协商一致，乙方向甲方订购以下产品：</p>
        <div class="ht el-table el-table--border el-table--fit el-table--striped el-table--enable-row-hover el-table--enable-row-transition">
          <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
              <colgroup>
                <col width="6%">
                <col width="42%">
                <col width="8%">
                <col width="8%">
                <col width="12%">
                <col width="12%">
                <col width="12%">
              </colgroup>
              <tbody>
                <tr class="el-table__row is-center">
                  <td class="is-center">
                    <div class="cell">
                      序号
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      品名、规格或型号
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      单位
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      数量
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      单价(含税)
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      总金额
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      实际结算金额
                    </div>
                  </td>
                </tr>
                <tr v-for="(poProduct,index) in poProductList" :key="index" class="el-table__row">
                  <td class="is-center">
                    <div class="cell">
                      {{ index+1 }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.productAliasName === null ? poProduct.productName:poProduct.productAliasName }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.productUnit }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.productAmount }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.productUnitPrice }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.productUnitPrice*poProduct.productAmount }}
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poProduct.settlementSum }}
                    </div>
                  </td>
                </tr>
                <tr class="el-table__row">
                  <td colspan="4">
                    <div class="cell ">
                      金额合计：{{ smalltoBIG(allTotalPrice) }}
                    </div>
                  </td>
                  <td colspan="3">
                    <div class="cell ">
                      (小写){{ allTotalPrice }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="content-text">
        <div class="ht el-table el-table--border el-table--fit el-table--striped el-table--enable-row-hover el-table--enable-row-transition">
          <div class="el-table__body-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%;">
              <colgroup>
                <col width="20%">
                <col width="80%">
              </colgroup>
              <tbody>
                <tr class="el-table__row is-center">
                  <td class="is-center">
                    <div class="cell">
                      补充条款：
                    </div>
                  </td>
                  <td class="is-center">
                    <div class="cell ">
                      {{ poinfo.supplementalTerms }}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="content-text2">
        <div>订单条款：</div>
        <div>1.按下列____<u>{{ this.saleModesName }}</u>____方式支付货款：</div>
        <div>A.甲方收到乙方上述全部货款后发货。乙方可选择以下任一方式支付货款：</div>
        <div>a.乙方自签订本合同五日内将上述全部货款汇至甲方指定账户，甲方收到全部货款后组织供货，乙方付款后将付款凭证交给甲方。</div>
        <div>b.乙方自签订本合同当日将上述全部货款的5%元汇至甲方指定账户作为订金，并将付款凭证交给甲方，甲方收到乙方的订金及本合同原件后组织备货，备货完毕后，甲方通知乙方付款提货，全部货款到达甲方账户后，甲方安排发货。</div>
        <div>双方确认，最终付款方式以乙方从a、b中实际选择的支付方式为准。</div>
        <div>B.付款方式为“____<u>{{ this.collectionPeriodTotal }}</u>____”，即：乙方自合同签订之日起_____日内付上述全部货款的______%；货到_______日内付清剩余全部货款。</div>
        <div>2.保修期：</div>
        <div>本合同甲方产品保修期自甲方交付（发货）之日起第90天开始计算，保修3年。乙方自行承诺超出本合同保修期和甲方保修服务范围的服务，由乙方自行承担。</div>
        <div>3.产品交付，验收：</div>
        <div>甲方产品交付(发货)后，以传真或在甲方电子商务网发布《发货信息通报及回执》，通知乙方。乙方应在货到3日内进行到货验收，对产品外观和性能进行检验，并对数量、型号予以确认。乙方将验收结果填写在甲方传真的《发货信息通报及回执》上，并加盖乙方单位公章或者有效印章，将《发货信息通报及回执》原件按甲方地址寄回。邮寄回执的费用由乙方承担。若甲方在发货后10日内未收到《发货信息通报及回执》原件，则视为乙方已收到货物并验收合格。</div>
        <div>4.开票：</div>
        <div>甲方在本合同货物发货之日起十日后开出发票，并邮寄给乙方。服务产品及非服务产品按国家规定税率分别开具发票。乙方在收到发票后应及时传真、邮件确认收票情况。 若乙方的开票单位有所变更(非事先约定的名称)，或者有多家开票单位，需填写附件《开票通知单》，应详细填写每项内容，以便甲方建立档案。</div>
        <div>5.乙方销售甲方货物须严格遵守甲方的价格体系，违者甲方将按乙方违规进行处罚，直至取消代理资格。</div>
        <div>6.违约责任：</div>
        <div>6.1 付款方式为A的情况下，乙方依照本合同约定向甲方支付的订金，冲抵货款，不办理退回，若乙方在甲方备货完成后4个工作日内未打款提货，则乙方应当向甲方支付违约金，计算方式为乙方逾期打款天数*合同金额的千分之二（2‰）。双方同意，违约金可直接从订金中扣除，订金扣除完毕，甲方有权解除合同。</div>
        <div>6.2 付款方式为B的情况下，乙方逾期付款的，应当向甲方支付违约金，计算方式为乙方逾期天数*逾期货款额的千分之八（8‰）。如逾期付款达到并超过60日的，乙方还应当向甲方支付总合同货款百分之五（5％）的违约金。</div>
        <div>6.3 本合同约定的货物为甲方为满足乙方的需要专门制作，除非甲方书面同意，乙方退货或者拒绝接收合同货物的，乙方应当向甲方支付退货、拒绝接受部分货款百分之二十（20％）的违约金。双方同意，若乙方有预付款，违约金可以直接从预付款扣除，不足部分由乙方继续负担。</div>
        <div>7.解决纠纷方式：</div>
        <div>本协议履行中发生争议，双方应友好协商解决。协商无法达成一致意见，任何一方可向本合同签订地人民法院 北京市海淀区人民法院提起诉讼。</div>
        <div>8.本合同未明事项，按甲乙双方签订的代理合作协议的有关条款执行。</div>
        <div>9.乙方承诺，遵守美国政府有关出口管制方面的法律法规，不将本协议约定的产品应用于违反美国政府出口管制方面的行业，不将本协议约定的产品在美国政府禁运的目的地国家销售。乙方违反该项承诺给甲方造成的损失，包括但不限于甲方向第三方支付的罚款、违约金、甲方为维护自己的合法权益支出的律师费、差旅费、鉴定费、公证费、认证费等 ，由乙方全额赔偿。</div>
        <div>10.甲乙双方共同确认，合同所有条款必须逐项填明不得涂改，本合同经甲方签署电子印章且乙方加盖公章后生效。</div>
        <div>11.本合同一式两份，甲乙双方各持一份。</div>
        <div>
          <table name="print">
            <tbody>
              <tr>
                <td>12.甲方汇款信息：</td>
                <td style="width:40px" />
                <td><b>公司全称：北京星网锐捷网络技术有限公司</b></td>
              </tr>
              <tr>
                <td />
                <td />
                <td><b>开&nbsp;户&nbsp;行：招商银行北京万寿路支行</b></td>
              </tr>
              <tr>
                <td />
                <td />
                <td><b>账&nbsp;&nbsp;&nbsp;&nbsp;户：861384337810001</b></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="signature">
        <el-row>
          <el-col :span="12">
            <p>甲方：北京星网锐捷网络技术有限公司</p>
            <p>授权代表(签字)：</p>
            <p><span style="width:8em;display: inline-block" />年<span style="width:4em;display: inline-block" />月<span style="width:4em;display: inline-block" />日</p>
          </el-col>
          <el-col :span="12">
            <p>乙方：</p>
            <p>授权代表(签字):</p>
            <p><span style="width:8em;display: inline-block" />年<span style="width:4em;display: inline-block" />月<span style="width:4em;display: inline-block" />日</p>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import { smalltoBIG, MathMulti } from '../../../libs/util';
export default {
  data () {
    return {
      tablemargin: '0 auto',
      tablePadding: '10px',
      poinfo: {
        buyerAddress: '此字段待后台提供'
      },
      poProductList: [],
      saleModesName: '',
      collectionPeriodTotal: '',
      consigneeName: '',
      consigneeUserName1: '',
      finalPostalCode: '',
      consigneeAddress: '',
      recipients: '',
      consigneeTel1: '',
      consigneeFax1: '',
      settlementSum: ''
    };
  },
  props: {
    contractNum: {
      type: String,
      required: true
    }
  },
  components: {},
  computed: {
    allTotalPrice () { // 退货金额合计
      let cont = 0;
      this.poProductList.forEach((item) => {
        cont += MathMulti(item.productAmount, item.productUnitPrice);
      });
      return cont.toFixed(2);
    }
  },
  methods: {
    smalltoBIG,
    initData () {
    },
    pageInited () {
      // 页面从初始加载完成，通知父frame可以显示打印按钮
      window.top.postMessage({
        event_id: 'contractAgreementLoaded'
      }, '*');
    }
  },
  mounted () {
    // this.initData();
    if (this.$route.name === 'contractAgreementPrint') {
      this.tablemargin = '0';
      this.tablePadding = '0';
    }
    this.pageInited();
  }
};
</script>
<style lang="scss" scoped>
  .ordercontractbox {
    background: #fff;
    width: 955px;
    padding: 0 10px;
    .title {
      text-align: center;
      color: #000;
    }

    .m-title {
      text-align: center;
      margin-bottom: 0.83rem;
    }

    .fang {
    }

    .content-text {
      margin-top: 30px;

      p {
        margin: 20px 0
      }
    }

    .content-text2 {
      margin-top: 30px;

      p {
        text-indent: 2em;
        margin: 10px 0;
      }

      div {
        margin: 10px 0;
      }
    }

    .signature {
      margin-top: 40px;
      line-height: 40px;
    }
  }

  .ht.el-table td, .el-table th {
    padding: 8px 0;
  }

  .ht.el-table {
    color: #333333;
  }
  .ht.el-table--border{
    border: 1px solid #999ba0 !important;
    td{
      border-right: 1px solid #999ba0;
      border-bottom: 1px solid #999ba0;
    }
  }
</style>
